import { render, staticRenderFns } from "./ProjectExplorer.vue?vue&type=template&id=bc5bc81c"
import script from "./ProjectExplorer.vue?vue&type=script&lang=js"
export * from "./ProjectExplorer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports